import { Box, Flex, Icon, Input, InputProps, Popover, PopoverContent, PopoverTrigger, Text } from '@chakra-ui/react'
import { useFormContext } from 'react-hook-form'
import InfoIcon from '@/public/assets/icons/info.svg'

export const VerifyFormInput = ({
  name,
  label,
  description,
  ...props
}: { name: string; description?: string; label?: string } & InputProps) => {
  const {
    register,
    formState: { errors },
  } = useFormContext()
  const error = errors[name]

  return (
    <Box mb={3}>
      <Flex alignItems={'center'} justifyContent={'space-between'}>
        {label && (
          <Text mb={1} fontSize={'sm'} fontWeight={700}>
            {label}
          </Text>
        )}
        {!!description && (
          <Popover placement={'top'}>
            <PopoverTrigger>
              <Icon cursor={'pointer'} color={'ninja.200'} as={InfoIcon} />
            </PopoverTrigger>
            <PopoverContent
              bg={'ninja.400'}
              p={2}
              border={'none'}
              rounded={'lg'}
              boxShadow={'0px 4px 32px 0px rgba(0, 0, 0, 0.24);'}
              maxW={'220px'}
              fontSize={'xs'}
              fontWeight={500}
              color={'ninja.100'}
              textAlign={'center'}
            >
              {description}
            </PopoverContent>
          </Popover>
        )}
      </Flex>
      <Input
        {...register(name)}
        {...props}
        px={4}
        variant={'unstyled'}
        h={'56px'}
        bg={'ninja.500'}
        rounded={'2xl'}
        fontWeight={700}
        fontSize={'sm'}
        _placeholder={{
          color: 'ninja.300',
        }}
        border={'2px solid'}
        borderColor={!!errors[name] ? 'brand.error' : 'transparent'}
      />
      {!!error && (
        <Text lineHeight={1.1} px={3} mt={1} fontWeight={700} fontSize={'xs'} color={'brand.error'}>
          {error.message?.toString() || ''}
        </Text>
      )}
    </Box>
  )
}
